import { Col, Sidepanel, Spinner2, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentHeader } from '../';
import { Post, Settings } from './components';

const UploadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: rgba(210, 216, 223, 0.7);
`;

const PostPanel = ({ dataId, setDataId, closeModal, hasBack }) => {
  const [uploading, setUploading] = useState(false),
    storedData = useSelector((state) => state.admin?.posts?.find((x) => x._id === dataId));

  useEffect(() => {
    setUploading(false);
  }, [dataId]);

  return (
    <Sidepanel wid={600} pad="0" visible={dataId} closeModal={uploading ? undefined : closeModal}>
      {uploading && (
        <UploadingOverlay>
          <Col centerAll ht="100%">
            <Col noFlex center>
              <Spinner2 />
            </Col>

            <Text med marg="24px 0 0">
              Please don't close this tab while your video is uploading
            </Text>
          </Col>
        </UploadingOverlay>
      )}

      <ContentHeader
        text={
          !storedData
            ? 'Create new post'
            : `Editing ${storedData?.owner?.name || storedData?.owner?.username}'s post`
        }
        SettingsComponent={() => <Settings post={storedData} closeModal={() => setDataId(null)} />}
        closePanel={hasBack && closeModal}
      />

      {dataId && (typeof dataId === 'string' ? !storedData : false) && (
        <Col
          zIndex={5}
          pos="absolute"
          ht="100%"
          wid="100%"
          bg="rgba(210, 216, 223, 0.7)"
          left="0"
          centerAll
        >
          <Spinner2 col={theme.SECONDARY} />
        </Col>
      )}

      {dataId && (typeof dataId === 'string' ? storedData : true) && (
        <Post
          post={storedData}
          setDataId={setDataId}
          closeModal={closeModal}
          isEditing={!!storedData}
          setUploading={setUploading}
          isProcessing={storedData?.processing}
        />
      )}
    </Sidepanel>
  );
};

export default PostPanel;
